/**
 * After a change: refresh every screen that shows what it touched
 * (docs/LIVE-DATA.md "the touch map"). Pass it as the mutation's `onSuccess`:
 * `orpc.items.create.mutationOptions({ onSuccess: useInvalidate('items') })`.
 */
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { invalidateTouched } from '@/lib/live-data'
import { type RecordKind, TOUCHES } from '../lib/live-data-registry.ts'

export function useInvalidate(...kinds: RecordKind[]): () => Promise<void> {
  const queryClient = useQueryClient()
  // Each kind once: a repeat would restart a fetch the first one just began.
  const key = [...new Set(kinds)].join(',')
  // `kinds` is a new array each render; its joined value is what stays stable.
  return useCallback(
    () => invalidateTouched(queryClient, TOUCHES, (key ? key.split(',') : []) as RecordKind[]),
    [queryClient, key],
  )
}
